module.exports = __webpack_public_path__ + "static/media/scholar.62488113.webp";